import { Tabs, Divider, Tab } from "@material-ui/core";
import { useState, useEffect, useCallback, Fragment } from "react";
import {
    Datagrid,
    TextField,
    ListProps,
    TextInput,
    DatagridProps,
    Identifier,
    ListContextProvider,
    useListContext,
    BooleanInput,
    BulkDeleteButton,
    NullableBooleanInput,
    NumberField,
    NumberInput,
    ReferenceArrayInput,
    AutocompleteArrayInput,
    SelectInput, AutocompleteInput, FunctionField,
} from "react-admin";
import { CustomList } from "../components/CustomList";
import { IdentifierField } from "../components/IdentifierField";
import { TextListField } from "../components/TextListField";
import { useOptionsResource } from "../shared/hooks/useOptionsResource";
import { initField, getDefaultListProps } from "../shared/utils";
import { AssociatMainSubjectButton } from "./AssociatMainSubjectButton";
import { AddOpeningSubjectBulkButton } from "./AddOpeningSubjectBulkButton";
import { useOptions } from "../shared/hooks/useOptions";
import {ChangePaymentTerms} from "./ChangePaymentTerms";

const tabs = [
  { id: "*", name: "tutti" },
  { id: "cliente", name: "clienti" },
  { id: "destinatario", name: "destinatari" },
  { id: "vettore", name: "vettori" },
  { id: "fornitore", name: "fornitori" },
  { id: "altro", name: "altri" },
  { id: "produttore", name: "produttori" },
];

const TabbedDatagrid = (props: DatagridProps) => {
  const listContext = useListContext();
  const { ids, filterValues, setFilters, displayedFilters } = listContext;
  const [all, setAll] = useState<Identifier[]>([] as Identifier[]);
  const [carrier, setCarrier] = useState<Identifier[]>([] as Identifier[]);
  const [receiver, setReceiver] = useState<Identifier[]>([] as Identifier[]);
  const [client, setClient] = useState<Identifier[]>([] as Identifier[]);
  const [supplier, setSupplier] = useState<Identifier[]>([] as Identifier[]);
  const [other, setOther] = useState<Identifier[]>([] as Identifier[]);
  const [productor, setProductor] = useState<Identifier[]>([] as Identifier[]);

  useEffect(() => {
    if (ids && ids !== filterValues.single_type) {
      switch (filterValues.single_type) {
        case "*":
          setAll(ids);
          break;
        case "vettore":
          setCarrier(ids);
          break;
        case "destinatario":
          setReceiver(ids);
          break;
        case "cliente":
          setClient(ids);
          break;
        case "fornitore":
          setSupplier(ids);
          break;
        case "altro":
          setOther(ids);
          break;
        case "produttore":
          setProductor(ids);
          break;
      }
    }
  }, [ids, filterValues.single_type]);

  const handleChange = useCallback(
    (event: React.ChangeEvent<{}>, value: any) => {
      setFilters &&
        setFilters({ ...filterValues, single_type: value }, displayedFilters);
    },
    [displayedFilters, filterValues, setFilters]
  );
  const { data: options } = useOptionsResource("GET");

  return (
    <Fragment>
      <Tabs
        variant="fullWidth"
        centered
        value={filterValues.single_type}
        indicatorColor="primary"
        onChange={handleChange}
      >
        {tabs.map((choice) => (
          <Tab key={choice.id} label={choice.name} value={choice.id} />
        ))}
      </Tabs>
      <Divider />
      {options ? (
        <div>
          {filterValues.single_type === "*" && (
            <ListContextProvider value={{ ...listContext, ids: ids }}>
              <Datagrid {...props}>
                <IdentifierField {...initField("id", options)} />
                <TextField {...initField("main_subject_id", options)} />
                <TextField {...initField("business_name", options)} />
                <TextListField {...initField("type", options)} />
                <TextField {...initField("locality", options)} />
                  <FunctionField label="Termini di pagamento" render={(record:any) => record.payment_terms ? record.payment_terms.label : "---"} />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.single_type === "vettore" && (
            <ListContextProvider value={{ ...listContext, ids: carrier }}>
              <Datagrid {...props}>
                <IdentifierField {...initField("id", options)} />
                <TextField {...initField("business_name", options)} />
                <TextListField {...initField("type", options)} />
                <TextField {...initField("locality", options)} />
                <TextField {...initField("province", options)} />
                  <FunctionField label="Termini di pagamento" render={(record:any) => record.payment_terms ? record.payment_terms.label : "---"} />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.single_type === "destinatario" && (
            <ListContextProvider value={{ ...listContext, ids: receiver }}>
              <Datagrid {...props}>
                <IdentifierField {...initField("id", options)} />
                <TextField {...initField("business_name", options)} />
                <TextListField {...initField("type", options)} />
                <TextField {...initField("locality", options)} />
                  <FunctionField label="Termini di pagamento" render={(record:any) => record.payment_terms ? record.payment_terms.label : "---"} />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.single_type === "cliente" && (
            <ListContextProvider value={{ ...listContext, ids: client }}>
              <Datagrid {...props}>
                <IdentifierField {...initField("id", options)} />
                <TextField {...initField("business_name", options)} />
                <TextListField {...initField("type", options)} />
                <TextField {...initField("locality", options)} />
                  <FunctionField label="Termini di pagamento" render={(record:any) => record.payment_terms ? record.payment_terms.label : "---"} />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.single_type === "fornitore" && (
            <ListContextProvider value={{ ...listContext, ids: supplier }}>
              <Datagrid {...props}>
                <IdentifierField {...initField("id", options)} />
                <TextField {...initField("business_name", options)} />
                <TextListField {...initField("type", options)} />
                <TextField {...initField("locality", options)} />
                  <FunctionField label="Termini di pagamento" render={(record:any) => record.payment_terms ? record.payment_terms.label : "---"} />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.single_type === "altro" && (
            <ListContextProvider value={{ ...listContext, ids: other }}>
              <Datagrid {...props}>
                <IdentifierField {...initField("id", options)} />
                <TextField {...initField("business_name", options)} />
                <TextListField {...initField("type", options)} />
                <TextField {...initField("locality", options)} />
                  <FunctionField label="Termini di pagamento" render={(record:any) => record.payment_terms ? record.payment_terms.label : "---"} />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.single_type === "produttore" && (
            <ListContextProvider value={{ ...listContext, ids: productor }}>
              <Datagrid {...props}>
                <IdentifierField {...initField("id", options)} />
                <TextField {...initField("business_name", options)} />
                <TextListField {...initField("type", options)} />
                <TextField {...initField("locality", options)} />
                  <FunctionField label="Termini di pagamento" render={(record:any) => record.payment_terms ? record.payment_terms.label : "---"} />
              </Datagrid>
            </ListContextProvider>
          )}
        </div>
      ) : null}
    </Fragment>
  );
};

export const SubjectList = (props: ListProps) => {
  const { data: options } = useOptionsResource("GET");

  const { data: optionsSubjectOpenings } = useOptions("subjectopenings", "GET");
  const { data: payment_terms } = useOptions("payment-terms", "GET");
  const filters = options && optionsSubjectOpenings && payment_terms
    ? [
      <NullableBooleanInput
        {...initField("is_not_main", options)}
        label="Ricerca soggetti secondari"
        alwaysOn
      />,
      <NullableBooleanInput
        {...initField("hide", options)}
        label="Nascosto"
        alwaysOn
        defaultChecked={false}
      />,
      <NullableBooleanInput
        {...initField("has_openings", options)}
        label="Orari apertiura?"
        alwaysOn
        defaultChecked={false}
      />,
      <TextInput alwaysOn {...initField("id", options)} />,
      <TextInput alwaysOn {...initField("business_name", options)} />,
      <NullableBooleanInput
        {...initField("not_valid_address", options)}
        label="Indirizzo non valido"
      />,
      <NumberInput {...initField("main_subject_id", options)} />,
      <TextInput {...initField("vat_number", options)} />,
      <TextInput {...initField("locality", options)} />,
      <TextInput {...initField("province", options)} />,
      <TextInput {...initField("provinces", options)} label="Province (sep ,)" />,
      <ReferenceArrayInput
        source="regions"
        label="Regioni"
        reference="autocomplete/region"
        className="filter-field-small"
      >
        <AutocompleteArrayInput optionText="label" />
      </ReferenceArrayInput>,
      <ReferenceArrayInput
        source="payment_terms"
        label="Termini di pagamento"
        reference="autocomplete/terms-payment"
        className="filter-field-small"
      >
        <AutocompleteArrayInput optionText="label" />
      </ReferenceArrayInput>,
      <SelectInput
          {...initField("terms_payment_method", options, "array")}
          choices={payment_terms.method.choices}
          className="filter-field-small"
          label="Tipologia pagamento"

      />,
      <ReferenceArrayInput
          source="terms_description"
          label="Termini"
          reference="autocomplete/terms-description"
          className="filter-field-small"
      >
          <AutocompleteArrayInput optionText="label" />
      </ReferenceArrayInput>,
      <SelectInput
        {...initField("open_on_day", options, "array")}
        choices={optionsSubjectOpenings.day.choices}
        alwaysOn
        className="filter-field-small"
        label="Aperto di"
      />,
      <NullableBooleanInput
          {...initField("print_a5", options)}
          label="Stampa in A5"
      />,
          <NullableBooleanInput
              {...initField("administrative_block", options)}
              label="Blocco amministrativo"
          />,
    ]
    : [];
  return options ? (
    <CustomList
      filters={filters}
      filterDefaultValues={{ single_type: "*", is_not_main: false }}
      {...getDefaultListProps(props)}
      bulkActionButtons={<>
        <AssociatMainSubjectButton />
        <AddOpeningSubjectBulkButton />
          <ChangePaymentTerms/>
        <BulkDeleteButton />
      </>}
    >
      <TabbedDatagrid />
    </CustomList>
  ) : null;
};
